import { render } from "./SearchResultsDropDown.vue?vue&type=template&id=35cec240"
import script from "./SearchResultsDropDown.vue?vue&type=script&lang=js"
export * from "./SearchResultsDropDown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__